import React, { useEffect, useRef } from 'react';

const members = [
    {
        name: 'Abenezer Merjan',
        role: 'CEO',
        image: 'assets/abenezer.jpg'
    },
    {
        name: 'Netsanet Neker',
        role: 'Backend Developer',
        image: 'assets/netsanet.jpg'
    },
    {
        name: 'Abdulwahid Munewer',
        role: 'Full-stack Developer',
        image: 'assets/abdulwahid.jpg'
    },
    {
        name: 'Abel Fkadu',
        role: 'Frontend Developer',
        image: 'assets/abel.jpg'
    },
    {
        name: 'Berhane Desse',
        role: 'Hardware Expert',
        image: 'assets/berhane.jpg'
    },
    {
        name: 'Melkamu Meles',
        role: 'Graphics Designer',
        image: 'assets/melkamu.jpg'
    }
];

const Member = () => {
    const scrollContainerRef = useRef(null);

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        let scrollAmount = 0;
        const scrollStep = 1; // Controls the speed of scrolling
        const scrollInterval = 20; // Controls the interval of scrolling

        const scroll = () => {
            if (scrollContainer) {
                scrollAmount += scrollStep;
                scrollContainer.scrollLeft = scrollAmount;
                if (scrollAmount >= scrollContainer.scrollWidth / 2) {
                    scrollAmount = 0; // Reset for continuous loop
                }
            }
        };

        const intervalId = setInterval(scroll, scrollInterval);

        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    return (
        <section id="team" className="px-5 py-5 w-full my-20 max-w-5xl mx-auto bg-orange-100">
            <h2 className="text-5xl font-bold text-orange-400 text-center mb-10">
                Team Members:
            </h2>
            <div 
                ref={scrollContainerRef} 
                className="flex overflow-x-hidden space-x-6 p-6 hide-scrollbar"
                aria-label="Team members scrolling list"
            >
                {[...members, ...members].map((member, index) => (
                    <div key={index} className="flex-none w-64 bg-orange-100 p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
                        <div className="w-32 h-32 mx-auto mb-4">
                            <img 
                                src={member.image} 
                                alt={`${member.name}, ${member.role}`} 
                                className="w-full h-full object-cover rounded-full" 
                                aria-label={`${member.name}, ${member.role}`} 
                            />
                        </div>
                        <h2 className="text-xl font-semibold text-center text-gray-800">{member.name}</h2>
                        <p className="text-center text-gray-600">{member.role}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Member;